import { connect } from 'react-redux';
import OutcomeView from "../components/OutcomeView/index.js";
import { getContextByScope } from "../store/context/selectors.js";
import { getFeatures } from "../store/features/selectors.js";
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getContextByScope;
  var scope = ownProps.scope;
  return {
    context: (_getContextByScope = getContextByScope(state, scope)) === null || _getContextByScope === void 0 ? void 0 : _getContextByScope.data,
    features: getFeatures(state)
  };
};
var ConnectedOutcomeView = connect(mapStateToProps)(OutcomeView);
export default ConnectedOutcomeView;